import React, { Component, useState, useEffect } from 'react'
import DocumentTitle from 'react-document-title'
import { observer, inject } from 'mobx-react'
import Spinner from '@components/spinner'
import Scroll from '@components/Scroll'
import Error from '@components/Error/NoContent'
import Button from '@components/Button'
import { SearchPanelContainer } from '@components/Search'

import WarningIcon from '@components/Icon/Warning'
import InfoBox from '@components/InfoBox'
import Input from '@components/Form/Input'
import RichTextEditor from '@components/RichTextEditor'

import EmailTemplatesTable from './EmailTemplatesTable'

const createableGroups = ['EPL_extract', 'expert_follow_up']

class EmailTemplates extends Component {
  constructor(props) {
    super(props)
    this.props.emailTemplatesStore.getAll()
  }

  render() {
    const store = this.props.emailTemplatesStore
    const { loading, error } = store

    if (error) {
      return <Error />
    }

    return (
      <DocumentTitle title="Email templates | Atheneum Partners">
        <div className="expert-search">
          <SearchPanel store={store} />
          <div className="expert-search-results">
            <Scroll>
              <div className="project-wrapper">
                <EditTemplate
                  store={store}
                  growlStore={this.props.growlStore}
                  setActiveTemplate={store.setActiveTemplate}
                  activeTemplate={store.activeTemplate}
                />
              </div>
            </Scroll>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

const validationMsg = field => store => {
  return (
    <div className="expert-form__input-error">
      {store?.touched?.includes(field) &&
        store?.validationErrors?.inner?.filter(error => {
          return field === error?.params?.path
        })[0]?.errors[0]}
    </div>
  )
}

const EditTemplate = observer(({ store, growlStore }) => {
  if (!store.activeTemplate) return <div>select template</div>
  const { placeholders } = store.activeTemplate

  return (
    <div className="email-template-edit-wrapper">
      <form
        onSubmit={e => {
          e.preventDefault()
          store
            .saveActive()
            .then(res => {
              growlStore.showSuccess('Template was successfully saved')
            })
            .catch(() => true)
          return false
        }}>
        <div className="form-section">
          <label>Name</label>
          <input
            data-cy="template-name-input"
            className="form-control"
            disabled={store.activeTemplate.id}
            onChange={e => store.setValue('name', e.target.value)}
            value={store.activeTemplate.name}
          />
          <div>{validationMsg('name')(store)}</div>
        </div>
        <div className="form-section">
          <label>Group</label>
          <select
            style={{
              border: '1px solid #d7dce4',
              borderRadius: 3,
              background: store.activeTemplate.id ? '#FAFAFC' : 'transparent'
            }}
            className="form-control select"
            data-cy="template-group-select"
            disabled={store.activeTemplate.id}
            onChange={e => store.setValue('group', e.target.value)}
            value={store.activeTemplate.group}>
            <option value={null}>Select group</option>
            {store.activeTemplate.id ? (
              <option value={store.activeTemplate.group}>
                {store.activeTemplate.group}
              </option>
            ) : (
              createableGroups.map(g => (
                <option key={g} value={g}>
                  {g}
                </option>
              ))
            )}
          </select>
          <div>{validationMsg('name')(store)}</div>
        </div>
        <div className="form-section">
          <label>Subject</label>
          <input
            className="form-control"
            value={store.activeTemplate.subject}
            data-cy="template-subject-input"
            onChange={e => store.setValue('subject', e.target.value)}
          />
          <div>{validationMsg('subject')(store)}</div>
        </div>
        <div className="form-section">
          <label>Content</label>
          <RichTextEditor
            className="form-control"
            height={1000}
            skipWrapper
            data-cy="template-body-input"
            value={store.activeTemplate.content}
            onChange={val => store.setValue('content', val)}
          />
          <div>{validationMsg('content')(store)}</div>
        </div>
        <div className="form-section">
          <Button data-cy="template-save-button" type="submit">
            Save
          </Button>
        </div>
      </form>
      <InfoBox className="placeholders" icon={null}>
        <h3>Placeholders</h3>
        <div dangerouslySetInnerHTML={{ __html: placeholders }} />
      </InfoBox>
    </div>
  )
})

const SearchPanel = ({ store }) => {
  const [templateFilter, setTemplateFilter] = useState('')
  const { templates, setActiveTemplate, loading } = store

  return (
    <SearchPanelContainer
      wide
      searchTitle="Email Templates"
      buttonProps={{
        buttonText: 'Create new template',
        onClick: () =>
          (store.activeTemplate = {
            id: '',
            name: '',
            subject: '',
            content: ''
          }),
        roles: ['AdvancedReporting', 'Admin']
      }}>
      <input
        placeholder="Filter templates"
        style={{ width: '100%' }}
        value={templateFilter}
        data-cy="template-filter-input"
        onChange={e => setTemplateFilter(e.target.value)}
      />

      {loading && <Spinner />}

      <ul className="email-template-list">
        {templates
          .filter(
            t =>
              t.name.includes(templateFilter) ||
              t.group.includes[templateFilter]
          )
          .map(t => (
            <li key={t.id}>
              <button
                className={
                  'link ' + (t.id === store.activeTemplate?.id ? 'active' : '')
                }
                onClick={() => setActiveTemplate(t)}>
                <span data-cy="template-name-span">{t.name}</span>{' '}
                <span className="email-template-group-name">{t.group}</span>
              </button>
            </li>
          ))}
      </ul>
    </SearchPanelContainer>
  )
}

export default inject(
  'emailTemplatesStore',
  'growlStore',
  'modalStore'
)(observer(EmailTemplates))
